import { createI18n } from 'vue-i18n'
import { Locale } from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'
import hiIN from 'vant/lib/locale/lang/hi-IN'
import en from './en'
import hi from './hi'
import { isInNativeApp, deviceInfo } from 'web-utils/device'

const navigatorLang = localStorage?.getItem('language') || window.navigator.language?.toLowerCase()
let locale = 'en'
if (navigatorLang.includes('hi')) {
  locale = 'hi'
} else {
  locale = 'en'
}
if (isInNativeApp()) {
  locale = deviceInfo()?.lang
}
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale,
  messages: {
    en,
    hi
  }
})

// 更新vant组件库本身的语言变化，支持国际化
function vantLocales(lang) {
  if (locale === 'en') {
    Locale.use(lang, enUS)
  } else if (locale === 'hi') {
    Locale.use(lang, hiIN)
  }
}
vantLocales(locale)

export default i18n
const lang = locale
export { lang }
